import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve held diverse leadership roles across retail banking, remittances,
                compliance, and financial planning. How have these cross-functional experiences
                shaped your approach to strategic decision-making at the executive level?
              </strong>
            </h5>

            <h5 className="text-white">
              In today’s world where banking works under a complex environment, to build best
              actions need agility and resilience which requires multifunctional exposure. The
              cross-functional exposure enables me to lead with a 360-degree view balancing bottom
              line (profitability) which is the main KPI with Control .i.e. through compliance
              learning. Servicing by recognizing customer needs and execution with good governance
              and effective operations
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As General Manager at UBL Qatar, you’ve led efforts to mobilize low-cost deposits,
                enhance asset returns, and improve recovery. What frameworks or principles guide
                your approach to balancing growth, profitability, and regulatory compliance in
                international markets?
              </strong>
            </h5>
            <h5 className="text-white">
              Strategic alignment, disciplined execution, and proactive governance was the mantra
              practiced all along bringing business to expected returns. Gulf countries have their
              unique look & feel making them indifferent from others, strategic segmental approach
              with on-shelve/tailored product suit. Initiatives have to be viewed through concrete
              risk adjusted lens with adequate consideration of cyclic risk and rewards. Well
              scrutinized on-boarding that targets consistent profits through shake hand in complete
              transactional trail benefits both ends. In last, close watch on the game, last you
              long.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-During your tenure as Global Head of Home Remittance & NRP Banking, UBL held the
                highest market share for inward remittances in Pakistan. What were the key enablers
                behind this success, and how do you see remittance channels evolving with digital
                disruption?
              </strong>
            </h5>
            <h5 className="text-white">
              Focused, multi-pronged strategy rooted in accessibility, trust, and digital innovation
              were the key principles experimented to bring remittance share to this height. Apart
              we definitely created enabling environment around Partners trust building, Compliant
              and improved TAT, Innovative and easy of customer experience. Digital disruption is
              already reshaping the landscape, will see paradigm shift due to incoming Fintech (and
              Telco’s), Gen Y – Z Wallet based transactions and Cross selling (Embedded Finance).
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-In your earlier role as CAMLO, you oversaw AML/CFT compliance during a crucial
                period of regulatory tightening. How do you maintain a strong compliance culture
                across geographically dispersed teams while enabling business agility?
              </strong>
            </h5>
            <h5 className="text-white">
              Mantra was to embed compliance into the culture, not just processes and enable the
              business to remain agile and growth-oriented. Smarter integration, accountability at
              every level, and continuous enablement through risk-aligned tools and training where
              key practices. This helped me remained both vigilant and commercially agile during a
              period of intense regulatory change
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve consistently led large teams and handled high-value portfolios. What’s your
                philosophy on people leadership, especially in high-pressure environments where
                targets, transformation, and compliance intersect?
              </strong>
            </h5>
            <h5 className="text-white">
              Clarity of purpose, empowerment with accountability, and resilience through trust are
              key, especially in high-pressure environments where performance, transformation, and
              compliance intersect. High performance is a byproduct of clarity, trust, and
              purpose—not pressure alone. By aligning people to the mission, equipping them to
              succeed, and leading with empathy, always tried to built resilient, high-performing
              teams even in the most demanding environments
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
